module.exports = __webpack_public_path__ + "img/option-carriere.672f440d.svg";